import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrowUpDown = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path
        d="M2 6.5L5 3.5M5 3.5L8 6.5M5 3.5V11M8 9.5L11 12.5M11 12.5L14 9.5M11 12.5V5"
        stroke={color}
      />
    </svg>
  ),
)
ArrowUpDown.displayName = 'ArrowUpDown'
ArrowUpDown.defaultProps = {
  width: 16,
  height: 16,
}

export default ArrowUpDown
